import { createTheme } from '@mui/material'

const base = {
  typography: {
    fontFamily: {
      Poppins: 'Poppins, sans-serif',
    }
  },
  shape: {
    borderRadius: 10,
  },
}

const lightPalette = {
  mode: 'light',
  primary: { main: '#d65944' },
  secondary: { main: '#d65944' },
}

const darkPalette = {
  mode: 'dark',
  primary: { main: '#e0715e' },
  secondary: { main: '#e0715e' },
  background: { default: '#0f1216', paper: '#171a1f' },
  text: { primary: '#f3f4f6', secondary: '#9aa4b2' },
  divider: '#2b313a',
}

const darkComponents = {
  MuiPaper: {
    styleOverrides: {
      root: { backgroundImage: 'none' }
    }
  },
  MuiDataGrid: {
    styleOverrides: {
      root: {
        borderColor: '#2b313a',
        color: '#e5e7eb',
        '--DataGrid-rowBorderColor': '#2b313a',
      },
      columnHeaders: { backgroundColor: '#1f242b', borderColor: '#2b313a' },
      columnHeader: { backgroundColor: '#1f242b' },
      cell: { borderColor: '#2b313a' },
      footerContainer: { borderColor: '#2b313a' },
      row: {
        '&:hover': { backgroundColor: '#262c34' },
        '&.Mui-selected': { backgroundColor: '#262c34' },
        '&.Mui-selected:hover': { backgroundColor: '#2b313a' },
      },
    }
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: { backgroundColor: '#262c34', color: '#f3f4f6' },
      arrow: { color: '#262c34' },
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      notchedOutline: { borderColor: '#2b313a' },
    }
  },
}

export const getMuiTheme = (mode) =>
  createTheme({
    ...base,
    palette: mode === 'dark' ? darkPalette : lightPalette,
    ...(mode === 'dark' ? { components: darkComponents } : {}),
  })

export default getMuiTheme('light')
